import {
  Box,
  InputLeftElement,
  Flex,
  Text,
  Input,
  Select,
  Radio,
  RadioGroup,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  InputGroup,
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";

const jobs = () => {
  // Dummy data for table rows
  const requestData = [
    {
      title: "NIG POD - November",
      reference: "LLS15747",
      items: "4",
      priority: "Low",
      deliverydate: "11/11/24",
      client: "HSBC Joanna Bloggs",
      assignedTo: "me",
      status: "Open",
    },
    {
      title: "Artwork",
      reference: "LS15747",
      items: "1",
      priority: "Low",
      deliverydate: "11/11/24",
      client: "HSBC Joanna Bloggs",
      assignedTo: "Lana Steiner",
      status: "Open",
    },
    {
      title: "Artwork",
      reference: "LS15747",
      items: "10",
      priority: "Low",
      deliverydate: "11/11/24",
      client: "HSBC Joanna Bloggs",
      assignedTo: "me",
      status: "Closed",
    },
    {
      title: "Artwork",
      reference: "LS15747",
      items: "2",
      priority: "Low",
      deliverydate: "11/11/24",
      client: "HSBC Joanna Bloggs",
      assignedTo: "Lana Steiner",
      status: "Closed",
    },
  ];

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="30px" color="#101828">
          Your jobs
        </Text>
      </Flex>

      {/* Filters Section */}
      <Flex gap={4} wrap="wrap" mb={6}>
        <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        <Select
          placeholder="Delivery date"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
        <Select
          placeholder="Priority (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="pending">Low</option>
          <option value="approved">High</option>
        </Select>
        <Select
          placeholder="Client (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="pending">Low</option>
          <option value="approved">High</option>
        </Select>
      </Flex>

      {/* Radio Buttons */}
      <RadioGroup mb={12} color="#475467">
        <Stack direction="row" align="center" color="#475467">
          <Text fontWeight="semibold" fontSize="12px" color="#475467" mr={4}>
            View:
          </Text>
          <Radio
            value="all"
            mr={4}
          >
            <Text fontSize="12px">All jobs</Text>
          </Radio>
          <Radio
            value="approved"
            mr={4}
          >
            <Text fontSize="12px">My jobs</Text>
          </Radio>
          <Radio
            value="pending"
          >
            <Text fontSize="12px">Unassigned jobs</Text>
          </Radio>
        </Stack>
      </RadioGroup>

      {/* Responsive Table */}
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Title
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Reference
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Items
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Priority
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Delivery date
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Client
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Assigned to
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Status
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              ></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index}>
                <Td pl={0} py={7} color="#475467" fontSize="12px">
                  {request.title}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.reference}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.items}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.priority}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.deliverydate}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.client}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.assignedTo}
                </Td>
                <Td pl={0}>
                  <Box
                    // px="10px"
                    // py="5px"
                    // borderRadius="54px"
                    // border="1px solid #4b5565"
                    // backgroundColor="transparent"
                    // fontSize="12px"
                    // fontFamily="Inter, sans-serif"
                    // color="#4b5565"
                    // textAlign="center"
                    // display="inline-block"
                    // width="100px"
                    // height="28px"
                    // lineHeight="18px"
                    px="10px"
                    py="5px"
                    borderRadius="54px"
                    border="1px solid #4b5565"
                    backgroundColor="transparent"
                    fontSize="12px"
                    fontFamily="Inter, sans-serif"
                    color="#4b5565"
                    textAlign="center"
                    display="inline-block"
                    minWidth="50px" 
                    maxWidth="200px" 
                    width="auto" 
                    height="28px"
                    lineHeight="18px"
                    whiteSpace="nowrap" 
                  >
                    {request.status}
                  </Box>
                </Td>
                <Td
                  pl={0}
                  color="#475467"
                  fontSize="12px"
                  textDecoration="underline"
                  cursor="pointer"
                >
                  View
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default jobs;
